import { createAction } from '@reduxjs/toolkit';

export const setReCaptchaAsLoaded = createAction(
  'reCaptcha/setReCaptchaAsLoaded'
);
